import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SvgIconModule } from 'shared/components/svg-icon/svg-icon.module';
import { WorkWidgetHeaderModule } from 'shared/components/work-widget-header/work-widget-header.module';
import { TranslateModule } from '@ngx-translate/core';
import { ChatPinInviteWidgetComponent } from './chat-pin-invite-widget.component';
import { CountdownTimerModule } from '../../../../../shared/components/countdown-timer/countdown-timer.module';
import { CustomPipesModule } from '../../../../../shared/pipes/custom-pipes.module';

@NgModule({
  imports: [
    CommonModule,
    SvgIconModule,
    WorkWidgetHeaderModule,
    CountdownTimerModule,
    TranslateModule.forChild(),
    CustomPipesModule
  ],
  providers: [
  ],
  declarations: [
    ChatPinInviteWidgetComponent
  ],
  exports: [
    ChatPinInviteWidgetComponent
  ]
})

export class ChatPinInviteWidgetModule {}
